import { always } from "../../../base/utils/ramdaEquivalents.utils";
import { makeObservableRouteDef } from "../../../base/utils/routes.utils";
import ModuleSupportGroups from "./SupportGroups.module";

export const SupportGroupsModuleRouteDef = makeObservableRouteDef({
  identifier: 'support-groups',
  urlFactory: always('support-groups'),
  composeTitle: always('Support Groups'),
  component: ModuleSupportGroups,
})